import { useNavigate } from "react-router-dom";

const NoPageScreen = () => {
    const navigate= useNavigate();
    return <h4>Page Not found. <span onClick={()=>{
        navigate('/')
    }} style={{color: 'blue', cursor: 'pointer'}}>Click to go back to The Dew Project</span></h4>;
  };
  
export default NoPageScreen;